module.exports = __webpack_public_path__ + "img/frame (284).b1caeb80.jpg";